export const FormAction = {
  SUBMIT: 'submit',
  SCRIPT_UPSERT: 'scriptUpsert',
} as const;
export type FormActionType = (typeof FormAction)[keyof typeof FormAction];

export interface ICreateSpotlightFormikValues {
  scriptId: number;
  text: string;
  title: string;
  action?: FormActionType;
  backgroundId: number;
}
